<div class="bg-white overflow-hidden shadow sm:rounded-lg manage-dispatch-filters-wrapper">
    <div class="w-full">
        <!-- Header -->
        <div class="border-b border-b-gray-300 zuper-dialog-header">
            <div class="flex justify-between">
                <h6 mat-dialog-title class="font-semibold primary-font">{{'dispatch.manage_filters.header.text' |
                    translate}}</h6>
            </div>
            <div class="flex items-center ml-auto">
                <span (click)="closeManageFilter()"
                    class="rounded-full flex justify-center items-center hover:bg-gray-200 h-9 w-9 p-2 cursor-pointer">
                    <em class="ti ti-x text-xl font-bold"></em>
                </span>
            </div>
        </div>
        <!-- Body -->
        <div class="manage-dispatch-filters-body-container overflow-hidden">
            <div class="flex h-full w-full" *ngIf="mockFiltersList?.length && isLoaded">
                <!-- Left Panel -->
                <div class="w-1/4 border-r border-r-gray-300 h-full">
                    <!-- Filter Search -->
                    <div class="p-4 border-b border-b-gray-300">
                        <div class="max-w-md w-full">
                            <div class="relative flex flex-col">
                                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <em class="ti ti-search cursor-pointer"></em>
                                </div>
                                <input type="text" id="searchKey" name="searchKey" [(ngModel)]="searchKey"
                                    (keyup)="triggerSearch(searchKey);" spellcheck="false"
                                    class="input-height text-base block w-full pl-10 pr-10 py-2.5 primary-font border border-gray-300 rounded-md bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:border-indigo-500"
                                    placeholder="{{'search_filter.text' | translate}}"
                                    autocomplete="off">
                                <div *ngIf="searchKey.length"
                                    class="h-9 w-9 mt-1 mr-0.5 cursor-pointer absolute inset-y-0 flex items-center justify-center right-0 rounded-full hover:bg-gray-100"
                                    (click)="searchKey = ''; triggerSearch(searchKey)">
                                    <em class="ti ti-x cursor-pointer"></em>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Filters List -->
                    <div class="manage-dispatch-filters-list overflow-y-auto overflow-x-hidden zuper-scrollbar">
                        <ng-container *ngFor="let filter of filtersList">
                            <div class="py-3.5 px-4 cursor-pointer" (click)="onSelectFilter(filter)"
                                [ngClass]="{'bg-gray-100':filter.filter_uid === selectedFilter.filter_uid, 'hover:bg-gray-50':filter.filter_uid !== selectedFilter.filter_uid}">
                                <p class="font-medium primary-font text-base truncate">{{filter.filter_name}}</p>
                            </div>
                        </ng-container>
                        <div *ngIf="!filtersList?.length" class="flex flex-col justify-center h-full">
                            <div class="flex justify-center content-center">
                                <div class="flex flex-col ">
                                    <div class="flex justify-center px-2 text-center primary-font break-words">
                                        <span class="">{{'dispatch.manage_filters.not_found.text' | translate}}
                                            '{{searchKey}}'</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Right Panel -->
                <div class="w-3/4 h-full">
                    <form class="primary-font w-full h-full" autocomplete="off" [formGroup]="filterApplicabilityForm">
                        <div class="w-full p-4 pb-0 pr-6 manage-dispatch-filter-applicability">
                            <div class="grid grid-cols-2 gap-4">
                                <div class="mb-4">
                                    <label class="block text-base mb-2 font-medium text-gray-600">
                                        {{'text.filter_name' | translate}}<span class="text-red-500"> *</span>
                                    </label>
                                    <input type="text" formControlName="filterName" name="filter_name" id="filter_name"
                                        class="mt-1 block w-full rounded-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
                                        placeholder="{{'text.filter_name' | translate}}">
                                    <span class="text-red-500 text-base mt-2" *ngIf="isInvalidValue('filterName')">
                                        {{'text.filter_name_required' | translate}}
                                    </span>
                                </div>
                                <div class="mb-4">
                                    <label class="block text-base mb-2 font-medium text-gray-600">
                                        {{'text.filter_applicability' | translate}}<span class="text-red-500"> *</span>
                                    </label>
                                    <ng-select class="manage-filter-applicability" [items]="applicabilities"
                                        bindLabel="applicableType" bindValue="applicableKey" [clearable]="false"
                                        [searchable]="false" [hideSelected]="false" appendTo="body"
                                        (change)="onSelectionChange($event)"
                                        placeholder="{{'dispatch.filter.filter_applicability.placeholder' | translate}}"
                                        formControlName="filterApplicability">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div class="primary-font text-base flex items-center">
                                                {{item.applicableType}}
                                            </div>
                                        </ng-template>
                                    </ng-select>
                                    <span class="text-red-500 text-base mt-2"
                                        *ngIf="isInvalidValue('filterApplicability')">
                                        {{'dispatch.filter.filter_applicability.error' | translate}}
                                    </span>
                                </div>
                            </div>
                            <div class="mb-4"
                                *ngIf="['USERS','TEAMS'].includes(filterApplicabilityForm.value?.filterApplicability)">
                                <label class="block text-base mb-2 font-medium text-gray-600">
                                    {{getLookupLabel() | translate}}
                                </label>
                                <ng-select class="applicability-dropdown" [items]="listValue$ | async"
                                    formControlName="applicabilityValues" bindValue="{{getLookupValueKey()}}"
                                    placeholder="{{getLookupPlacehodler() | translate}}" appendTo="body"
                                    [multiple]="true" [hideSelected]="false" [loading]="lookupLoading"
                                    [closeOnSelect]="false" (clear)="onItemsClear()"
                                    typeToSearchText="{{'info.type_to_search_text' | translate}}" [typeahead]="valueSubject$"
                                    (scrollToEnd)="appendValueToItems()">
                                    <ng-container
                                        *ngIf="filterApplicabilityForm.value?.filterApplicability === 'USERS'">
                                        <ng-template ng-option-tmp let-item="item" let-item$="item$"
                                            let-search="searchTerm" let-index="index">
                                            <div class="flex">
                                                <input id="item-{{index}}" type="checkbox" class="mr-4"
                                                    [checked]="item$.selected" (change)="$event.stopPropagation()" />
                                                <div>
                                                    <p class="text-base primary-font">{{item.first_name + ' ' +
                                                        item.last_name}}</p>
                                                    <p class="text-md primary-font text-secondary">{{ item.email}}</p>
                                                </div>
                                            </div>
                                        </ng-template>
                                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                            <div class="primary-font ng-value" *ngFor="let item of items | slice:0:2"
                                                [ngClass]="{'hidden' : items.length > 2}">
                                                <span class="ng-value-label text-base">{{item.first_name ||
                                                    ''}} {{item.last_name ||
                                                    ''}} - {{item.email || ''}}</span>
                                                <span class="ng-value-icon right text-base" (click)="clear(item)"
                                                    aria-hidden="true">×</span>
                                            </div>
                                            <div class="ng-value" *ngIf="items.length > 2">
                                                <span class="primary-font ng-value-label text-base">
                                                    {{items.length}} {{'dispatch.filter.applicability_users.selected_text' | translate}}</span>
                                            </div>
                                        </ng-template>
                                    </ng-container>
                                    <ng-container
                                        *ngIf="filterApplicabilityForm.value?.filterApplicability === 'TEAMS'">
                                        <ng-template ng-option-tmp let-item="item" let-item$="item$"
                                            let-search="searchTerm" let-index="index">
                                            <input id="item-{{index}}" type="checkbox" class="mr-2"
                                                [checked]="item$.selected" (change)="$event.stopPropagation()" />
                                            <span class="text-base primary-font">{{item.team_name || ''}}</span>
                                        </ng-template>
                                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                            <div class="primary-font ng-value" *ngFor="let item of items | slice:0:2"
                                                [ngClass]="{'hidden' : items.length > 2}">
                                                <span class="ng-value-label text-base">{{item.team_name || ''}}</span>
                                                <span class="ng-value-icon right text-base" (click)="clear(item)"
                                                    aria-hidden="true">×</span>
                                            </div>
                                            <div class="ng-value" *ngIf="items.length > 2">
                                                <span class="primary-font ng-value-label text-base">
                                                    {{items.length}} {{'text.teams_selected' | translate}}</span>
                                            </div>
                                        </ng-template>
                                    </ng-container>
                                </ng-select>
                                <span class="text-red-500 text-base mt-2" *ngIf="isInvalidValue('applicabilityValues')">
                                    {{getLookupError() | translate}}
                                </span>
                            </div>
                        </div>
                        <div *ngIf="isFilterOptionLoading" class="flex justify-center items-center h-full">
                            <lazy-loader></lazy-loader>
                        </div>
                        <div class="w-full border-t border-gray-300" [ngClass]="{
                        'filter-not-applicable-everyone': ['USERS','TEAMS'].includes(filterApplicabilityForm.value?.filterApplicability),
                        'filter-applicable-everyone': !['USERS','TEAMS'].includes(filterApplicabilityForm.value?.filterApplicability),
                        'filter-applicability-error': isInvalidValue('applicabilityValues'),
                        'filter-name-error': isInvalidValue('filterName')}">
                            <app-dispatch-filter *ngIf="!isFilterOptionLoading" class="w-full h-full" [isNewFilter]="false" [isMapViewEnabled]="isMapViewEnabled" [selectedModule]="'GRID'"
                                [filterFormGroup]="filterApplicabilityForm" [filterOptions]="filterOptions" [moduleAccess]="moduleAccess" [parentModule]="'dispatch_manage_filter'"
                                [dispatchFilterValues]="selectedFilter?.filter_options" [currentTab]="currentTab" [additionalFilters]="additionalFilters" [filterTabs]="filterTabs"></app-dispatch-filter>
                        </div>
                    </form>
                </div>
            </div>
            <ng-container *ngIf="!mockFiltersList?.length && !isFilterOptionLoading">
                <div *ngIf="!isLoaded" class="flex justify-center items-center h-full">
                    <lazy-loader></lazy-loader>
                </div>
                <div *ngIf="isLoaded" class="flex flex-col justify-center h-full">
                    <div class="flex justify-center content-center">
                        <img src="assets/images/svgs/new_filter.svg" alt="New Filter" class="h-60" />
                    </div>
                    <div class="flex justify-center content-center mt-2">
                        <div class="flex flex-col">
                            <div class="flex justify-center content-center ml-4 mt-2 primary-font font-semibold">
                                <span class="">{{'dispatch.manage_filters.no_data.message' | translate}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="flex justify-center content-center mt-3">
                        <div class="flex flex-col">
                            <button type="button" (click)="createNewFilter()"
                                class="ml-auto inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none">
                                {{'dispatch.manage_filters.create_new.text' | translate}}</button>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
        <!-- Footer -->
        <div mat-dialog-actions class="manage-dispatch-filter-footer-container flex justify-between border-t border-gray-300 zuper-dialog-footer">
            <div>
                <button *ngIf="selectedFilter && !showSpinner && isLoaded"
                    class="px-6 items-center py-2 shadow-sm text-base font-medium rounded-md text-white text-white-600 bg-red-600 btn-small focus:outline-none"
                    (click)="removeSelectedFilter()">{{'delete.text' | translate}}</button>
            </div>
            <div class="flex justify-around gap-4">
                <button type="button" (click)="closeManageFilter()"
                    class="ml-auto inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none">
                    {{'cancel.text' | translate}}</button>
                <button (click)="updateFilter()" [disabled]="!selectedFilter || !mockFiltersList?.length"
                    class="flex bg-primary px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-white text-base font-medium rounded-md text-white-600 btn-small focus:outline-none">
                    <ng-container *ngIf="!showSpinner">{{'text.save' |
                        translate}}</ng-container>
                    <div *ngIf="showSpinner">
                        <mat-progress-spinner id="save_dispatch_manage_filter" [diameter]="24"
                            [mode]="'indeterminate'"></mat-progress-spinner>
                    </div>
                </button>
            </div>
        </div>
    </div>
</div>